const translations = {
  verifyEmail: 'Please, verify your email address',
  goToSettings: 'Go to account Settings',
  upgrade: 'Not enough seats in your payment plan, please upgrade',
};
  
export default translations;
  